const CATALOG_PRODUCT_BASE_PATH = '/catalog/group'

export const getCatalogProductPath = (sef: string): string =>
  `${CATALOG_PRODUCT_BASE_PATH}/${sef}/`
